const MailCircleSignature = ({
  width = '40',
  height = '40',
}: {
  width?: string;
  height?: string;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="1" width="38" height="38" rx="19" fill="#F2F2F2" />
      <rect
        x="1"
        y="1"
        width="38"
        height="38"
        rx="19"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M30 16.608V24.75C30 26.483 28.6435 27.8992 26.9344 27.9949L26.75 28H13.25C11.517 28 10.1008 26.6435 10.0051 24.9344L10 24.75V16.608L19.652 21.6644C19.87 21.7785 20.13 21.7785 20.348 21.6644L30 16.608ZM13.25 12H26.75C28.4347 12 29.8201 13.2819 29.9838 14.9235L20 20.1533L10.0162 14.9235C10.1739 13.3427 11.4643 12.0954 13.0641 12.0052L13.25 12H26.75H13.25Z"
        fill="url(#paint0_linear_138_3090)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_138_3090"
          x1="27.9999"
          y1="12.064"
          x2="15.1589"
          y2="34.6563"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#298EE6" />
          <stop offset="1" stopColor="#7AB5E8" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default MailCircleSignature;
